<template>
  <div :class="className">
    <div class="flex flex-wrap -mx-2">
      <div class="flex-grow px-2">
        <label :for="id" v-if="label" class="block mb-2">{{ label }}</label>
      </div>
      <div class="flex-shrink px-2">
        <tooltip v-if="tooltip">{{ tooltip }}</tooltip>
      </div>
    </div>
    <div class="flex" v-if="canAddNewItems">
      <div class="flex-grow">
        <input
          type="text"
          :id="id"
          v-model="newTag"
          @paste.prevent="paste"
          @input="handleInput"
          class="w-full py-2 px-3 border-2 rounded-l bg-white outline-none focus:border-primary-500"
          :class="errorBag && errorBag.get(errorKey) ? 'border-red-600 hover:border-red-700' : 'border-gray-300 hover:border-gray-400'"
          :placeholder="placeholder"
          :disabled="disabled"
          @keydown.enter="addTag"
        />
      </div>
      <div class="flex-shrink flex items-stretch">
        <button
          type="button"
          class="px-3 py-2 rounded-r outline-none inline-block bg-secondary self-stretch hover:bg-secondary-darker"
          @click.prevent="addTag"
          title="Add Tag"
        >
          <i class="fas fa-fw fa-plus"></i>
        </button>
      </div>
    </div>

    <div>
      <button
        type="button"
        v-for="(tag, i) in content"
        :key="i"
        class="px-3 py-2 mr-2 mt-6 rounded outline-none inline-block bg-secondary hover:bg-secondary-darker"
        :class="errorBag && errorBag.get(`${errorKey}.${i}`) ? 'bg-red-200 hover:bg-red-300 border-red-600 border-2' : ''"
        :title="errorBag && errorBag.get(`${errorKey}.${i}`) ? errorBag.get(`${errorKey}.${i}`) : 'Remove tag'"
        @click="removeTag(tag)"
      >
        {{ tag }}
        <i class="fas fa-times-circle"></i>
      </button>
    </div>

    <div v-if="errorBag && errorBag.get(errorKey)" class="text-red-600 text-sm mt-2 font-bold">
      <i class="fas fa-exclamation-triangle"></i>
      {{ errorBag.get(errorKey) }}
    </div>
  </div>
</template>

<script>
import randomstring from 'randomstring'

export default {
  props: {
    className: {
      type: String,
      default: ''
    },
    label: {
      type: String
    },
    errorBag: {
      type: Object
    },
    errorKey: {
      type: String
    },
    value: {
      type: Array
    },
    uppercase: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String
    },
    tooltip: {
      type: String
    },
    disabled: {
      type: Boolean,
      default: false
    },
    canAddNewItems: {
      type: Boolean,
      default: true
    },
    format: {
      type: RegExp,
      default: null
    }
  },
  data () {
    return {
      id: randomstring.generate(),
      newTag: '',
      content: []
    }
  },
  created () {
    for (let i = 0; i < this.value.length; i++) {
      this.newTag = this.value[i]
      this.addTag()
    }
  },
  methods: {
    handleInput () {
      this.$emit('input', this.content)
    },
    addTag () {
      let tag = this.uppercase ? this.newTag.toUpperCase().trim() : this.newTag.trim()
      if (this.format) {
        const matches = tag.match(this.format)
        tag = matches.length ? matches[0] : ''
      }
      if (!tag) {
        return
      }
      if (this.content.indexOf(tag) !== -1) {
        this.newTag = ''
        return
      }
      this.errorBag.clear()
      this.content.push(tag)
      this.content.sort()
      this.newTag = ''
      this.handleInput()
    },
    removeTag (tag) {
      if (this.errorBag) {
        this.errorBag.clear()
      }
      this.content.splice(this.content.indexOf(tag), 1)
    },
    paste (e) {
      let data = e.clipboardData.getData('text/plain').split(',')
      for (let i = 0; i < data.length; i++) {
        this.newTag = data[i]
        this.addTag()
      }
    }
  },
  watch: {
    value: function () {
      this.content = this.value
    }
  }
}
</script>
